// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3XBse","label":"Section_label__3QQdF","contentWrap":"Section_contentWrap__17k1k","footer":"Section_footer__O8DT8","footerInner":"Section_footerInner__OlMtO"};